import React, { useEffect, useState } from "react";
import styles from "./communication.module.css";
import ChatDetails from "./components/chat-details/chat-details";
import { useChat } from "../../context/chat-context";
import { getChatRules } from "../../services/communication";
import ChatSidebar from "./components/chat-sidebar/chat-sidebar";
import { useSelector } from "react-redux";

const Communication = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [chatRules, setChatRules] = useState();
  const { selectedChat, setSelectedChat, setChatHistory } = useChat();
  const user = useSelector((state) => state.user?.user);
  const userRole = user?.role;

  useEffect(() => {
    fetchChatRules();
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => {
      setSelectedChat(null);
      setChatHistory([]);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const fetchChatRules = async () => {
    try {
      const response = await getChatRules();
      if (response?.status) {
        const data = response?.data?.data?.[userRole];
        setChatRules(data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      <div className={styles["heading-wrapper"]}>
        <div className={styles["heading"]}>My Chats</div>
      </div>

      {isMobile ? (
        <div className={styles["all-chat-container"]}>
          {selectedChat ? (
            <ChatDetails 
              selectedChat={selectedChat} 
              setSelectedChat={setSelectedChat}
              chatRules={chatRules}
            />
          ) : (
            <ChatSidebar 
              selectedChat={selectedChat}
              setSelectedChat={setSelectedChat}
              chatRules={chatRules}
            />
          )}
        </div>
      ) : (
        <div className={styles["all-chat-container"]}>
          <ChatSidebar 
            selectedChat={selectedChat}
            setSelectedChat={setSelectedChat}
            chatRules={chatRules}
          />
          <div style={{ paddingLeft: "16px", width: "100%" }}>
            {selectedChat ? (
              <ChatDetails 
                selectedChat={selectedChat} 
                setSelectedChat={setSelectedChat}
                chatRules={chatRules}
              />
            ) : (
              <h2>Select a chat to view the conversation</h2>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Communication;
